define([
    '@fancyapps/fancybox'
], function() {
    var _self;
    // console.log('events');

    // obj
    _self = {
    };


    // -------------------
    // BINDS
    // -------------------

    $.fancybox.defaults.hash = false;
    $.fancybox.defaults.backFocus = false;

    $('[data-fancybox]').fancybox({
        thumbs: false,
    	image: {
    		protect: true
    	}
    });

    // $('[data-fancyBox]')

    return _self;
});
